export default "__VITE_ASSET__87e681c6__"